// path: src/pages/IPA/Negociacoes/pages/NegociacaoFornecedor/acoesPorVisao.ts
/** O estado em que uma ação da barra chega à tela. */
export type BarActionState = {
  /** Se o botão é desenhado. Ocultar uma ação não é o mesmo que oferecê-la indisponível. */
  rendered: boolean;
  disabled: boolean;
};

/** As três ações da barra que GRAVAM, e só elas. */
export type WritingBarActions = {
  save: BarActionState;
  addToSavedNegotiation: BarActionState;
  addSellinAllowance: BarActionState;
};

export type WritingBarActionsInput = {
  isSelectionEmpty: boolean;
};

/** O estado das três ações que gravam, a partir do estado da seleção — e de nada mais. */
export const resolveWritingBarActions = ({ isSelectionEmpty }: WritingBarActionsInput): WritingBarActions => ({
  save: {
    rendered: true,
    disabled: isSelectionEmpty,
  },
  addToSavedNegotiation: {
    // Continua sendo desenhada só quando há seleção, exatamente como sempre foi.
    rendered: !isSelectionEmpty,
    disabled: false,
  },
  addSellinAllowance: {
    // Só existe com seleção, porque só aí há a quem aplicar. Sem condição por agrupamento: a rota
    // atende os três grãos.
    rendered: !isSelectionEmpty,
    disabled: false,
  },
});
